import { useEffect } from 'react';
import AdyenService from '../../business/processors/adyen/AdyenService';
import { useDispatch } from 'react-redux';
var Adyen = function Adyen(_ref) {
  var callback = _ref.callback;
  var dispatch = useDispatch();
  useEffect(function () {
    new AdyenService({
      dispatch: dispatch,
      callback: callback
    });
  }, []);
  return null;
};
export default Adyen;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/Adyen/Adyen.js
// module id = 4602
// module chunks = 11